import { createSlice } from '@reduxjs/toolkit';

/**
 * 初期型
 */
export interface SeoTextState {
  titleOrText: string;
  text: string;
  areaText: string;
  careerExplainText: string;
  defaultFlg: boolean;
}

// 初期状態
export const seoTextInitialState: SeoTextState = {
  titleOrText: '',
  text: '',
  areaText: '',
  careerExplainText: '',
  defaultFlg: false,
};

/**
 * SeoText Slice
 * @remarks Seoテキストの情報を保存
 */
export const seoTextSlice = createSlice({
  name: 'seoText',
  initialState: seoTextInitialState,
  reducers: {
    setSeoText: (state, action) => {
      state.titleOrText = action.payload.titleOrText;
      state.text = action.payload.text;
      state.careerExplainText = action.payload.careerExplainText;
      state.defaultFlg = action.payload.defaultFlg;
      state.areaText = action.payload.areaText;
    },
  },
});

export const { setSeoText } = seoTextSlice.actions;

// reducer
export const seoTextReducer = seoTextSlice.reducer;

// selector

interface State {
  seoText: SeoTextState;
}

/**
 * seoTextSelector
 * @param state
 */
export const seoTextSelector = <S extends State>(state: S) => state.seoText;
